import { useEffect, useState } from 'react';

import { BalanceType, ContractBalanceOf } from '@/types';
import { useWeb3 } from '@/hooks/use-web3';
import { fiexdDecimal, NumWithComma } from '@/lib/BigNumbers';
import { COIN_NAME_POL, COIN_NAME_SFL, COIN_NAME_USDT, METHODS_BALANCE_OF } from '@/lib/common/name-space';
import { weiToEth } from '@/lib/web3/utils';

export default function Balance(payload: BalanceType) {
  const { chainId, symbol, token } = payload;
  const { web3authCall } = useWeb3();
  const [amount, setAmount] = useState('0');
  useEffect(() => {
    (async () => {
      if (web3authCall?.connected()) {
        const address = await web3authCall.getAddress();
        console.log(symbol);
        let res = null;
        if (token) {
          // erc20
          const payload = {
            method: METHODS_BALANCE_OF,
            symbol,
            address,
          };
          res = await web3authCall.getRpc().contractCall<ContractBalanceOf>(payload);
          res = NumWithComma(fiexdDecimal(weiToEth(res)));
        } else {
          // 기반 코인
          res = NumWithComma(fiexdDecimal(await web3authCall.getRpc().getBalance(address)));
        }
        setAmount(res ? res : '0');
        // const re = await web3authCall.getRpc().getBalance(token, symbol, address);
        // console.log(`balance`);
        // console.log(re);
      }
    })();
    return () => {};
  }, [symbol, chainId, token, web3authCall]);

  return (
    <>
      {symbol} {amount}
    </>
  );
}
